export const calculateExchangeRate = (amount, fromCurrency, toCurrency) => {
  const rate = (amount / fromCurrency) * toCurrency;
  return rate.toFixed(6);
};
